export default function buildInitialState({
  membershipDiscountRate,
  subscribableVariantFreeFrequency,
  pricePerPod,
}) {
  return {
    membershipDiscountRate:
      membershipDiscountRate || 1.0 / (1.0 + subscribableVariantFreeFrequency),
    podPackPrice: pricePerPod,
  };
}
